module.exports = __webpack_public_path__ + "img/auth-bg-min.e64ca29e.png";